import * as Yup from 'yup';

export const buyerCrossSellFormValidator = Yup.object().shape({
  amount: Yup.string()
    .required('Please enter an amount')
    .test(
      'is-valid-amount',
      'Please enter an amount between £1,000 and £1,000,000',
      (value) => {
        if (!value) return false;
        const num = parseFloat(value.replace(/,/g, ''));
        return num >= 1000 && num <= 1000000;
      },
    ),
  purpose: Yup.string().required('Please select a purpose for the funds'),
  turnover: Yup.string().required(
    'Please enter your turnover of the last 12 months',
  ),
});
